<template>
  <div id="list-users">
    <TitleComponent />
    <div class="d-lg-flex">
      <div class="col-lg-3 p-1">
        <div class="card mt-3 p-3">
          <div class="card-body">
            <UserCreateComponent />
          </div>
        </div>
      </div>
      <div class="col p-1">
        <div class="card mt-3 p-3">
          <div class="card-body">
            <div class="d-lg-flex d-md-flex">
              <div class="p-1">
                <label for="exampleFormControlInput6">Search</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleFormControlInput6"
                  placeholder="Search here"
                  v-model="search"
                  @keyup.enter="readAll"
                />
              </div>
            </div>
            <div class="table-container mt-2">
              <div class="table-wrapper">
                <table class="table table-sm table-hover table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th width="10">No</th>
                      <th width="100">Company</th>
                      <th width="100">Fullname</th>
                      <th width="100">Username</th>
                      <th width="100">Level</th>
                      <th width="100" class="fixed-col">Aksi</th>
                    </tr>
                  </thead>
                  <tbody v-if="datas && datas.length > 0">
                    <tr v-for="(n, i) in datas" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td>{{ n.compname }}</td>
                      <td>{{ n.fullname }}</td>
                      <td>{{ n.username }}</td>
                      <td>{{ n.levelname }}</td>
                      <td class="fixed-col">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div
                            class="icon-card"
                            data-bs-toggle="modal"
                            data-bs-target="#modaDetailUser"
                            @click="detailUser(n.usercode)"
                          >
                            <i class="fas fa-edit icon"></i>
                          </div>
                          <div
                            class="icon-card"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteModal"
                            @click="id = n.usercode"
                          >
                            <i class="fas fa-trash icon"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="datas && datas.length < 1">
                    <tr class="text-center">
                      <td colspan="6" class="p-2">Data is missing</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="table-footer mt-2 d-lg-flex d-md-flex justify-content-between align-items-center"
            >
              <DataPageComponent
                :perPage="pagination.perPage"
                :currentPage="pagination.currentPage"
                :totalItems="pagination.totalItems"
              />
              <div
                class="col d-flex justify-content-lg-end justify-content-md-end justify-content-center"
              >
                <PaginationComponent
                  :pagination="pagination"
                  @goto-page="readAll"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <UserDetailComponent :userDetail="userDetail" />
    <DeleteModalComponent
      title="DELETE USER"
      descript="USER ?"
      :id="id"
      @saveDelete="deleteUser"
    />
  </div>
</template>
<script>
import DataPageComponent from "@/components/DataPageComponent.vue";
import DeleteModalComponent from "@/components/DeleteModalComponent.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import TitleComponent from "@/components/TitleComponent.vue";
import UserCreateComponent from "@/components/users/UserCreateComponent.vue";
import UserDetailComponent from "@/components/users/UserDetailComponent.vue";
import { getPage } from "@/utils/HandleToken";
import { mapActions, mapState } from "vuex";

export default {
  name: "UsersView",
  data() {
    return {
      id: "",
    };
  },
  components: {
    TitleComponent,
    PaginationComponent,
    UserDetailComponent,
    DeleteModalComponent,
    UserCreateComponent,
    DataPageComponent,
  },
  computed: {
    ...mapState({
      datas: (state) => state.Users.users,
      pagination: (state) => state.Users.pagination,
      userDetail: (state) => state.Users.userDetail,
    }),
    search: {
      get() {
        return this.$store.state.Users.search;
      },
      set(value) {
        this.$store.commit("Users/SET_SEARCH", value);
      },
    },
  },
  methods: {
    ...mapActions({
      readAll: "Users/readAll",
      detailUser: "Users/readOne",
      deleteUser: "Users/delete",
      readListCompany: "Company/readList",
    }),
  },
  created() {
    const currentPpage = getPage();
    this.readAll(currentPpage);
    this.readListCompany();
  },
};
</script>
